<ion-header [translucent]="true" class="mobile-header !border-b-0 md:!border-b">
  <ion-toolbar class="toolbar-with-closing-button !px-2 md:!px-4">
    <div slot="start" class="hidden md:flex md:w-8">
      <dojo-icon-button (click)="closeDialog()" [icon]="'times'"></dojo-icon-button>
    </div>
    <div slot="end" class="hidden md:flex md:w-8"></div>
    <ion-title class="common-ion-title">{{ 'assessment.popup.filters' | transloco }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="flex flex-col px-4 pb-4 md:px-6">
    <form [formGroup]="filteringService().formGroup" class="w-full">
      @if (state.hasFilters && (filteringService().filterColumns().length > 1 || !hasTopicFilter())) {
        <div @appearDisappearWithHeight>
          <div class="test border-b border-neutral-200 py-6">
            <h4 class="text-md text-primary mb-4 font-semibold">
              {{ 'assessment.popup.selected' | transloco }}
            </h4>
            <div class="flex flex-wrap gap-3">
              @for (filterColumn of filteringService().filterColumns(); track $index) {
                @if (filterColumn.filter === ExternalFilterType.Checkbox && filterColumn.options?.length) {
                  @if (filterColumn.formCtrl.value) {
                    @for (value of filterColumn.formCtrl.value; track value) {
                      <div class="selected-values">
                        <span class="selected-values-text">{{ value }}</span>
                        <button class="selected-values-button" (click)="removeCheckboxValue(filterColumn.colId, value)">
                          <dojo-icon [icon]="'times'" class="text-sky-500"></dojo-icon>
                        </button>
                      </div>
                    }
                  }
                }

                @if (filterColumn.filter === ExternalFilterType.Range && filterColumn.options?.length) {
                  @if (filterColumn.formCtrl.value) {
                    <div class="selected-values">
                      <span class="selected-values-text"
                        >{{ filterColumn.label }} : {{ filterColumn.formCtrl.value[0] }} -
                        {{ filterColumn.formCtrl.value[1] }}</span
                      >
                      <button class="selected-values-button" (click)="removeRangeValue(filterColumn.colId)">
                        <dojo-icon [icon]="'times'" class="text-sky-500"></dojo-icon>
                      </button>
                    </div>
                  }
                }
              }
            </div>
          </div>
        </div>
      }

      @for (filterColumn of filteringService().filterColumns(); track $index) {
        @if (filterColumn.filter === ExternalFilterType.Checkbox && filterColumn.options?.length) {
          <div class="py-6">
            <dojo-list-view-checkbox-filter
              [formCtrl]="filterColumn.formCtrl"
              [label]="filterColumn.label"
              [options]="filterColumn.options ?? []"
            />
          </div>
        }

        @if (hasTopicFilter() && filterColumn.filter === ExternalFilterType.Range && filterColumn.options?.length) {
          <div class="border-t border-neutral-200 py-6">
            <dojo-list-view-range-filter
              [formCtrl]="filterColumn.formCtrl"
              [label]="filterColumn.label"
              [subText]="filterColumn.subText"
              [options]="filterColumn.options ?? []"
              [step]="filterColumn.step"
            />
          </div>
        }
      }
    </form>
  </div>
</ion-content>
<ion-footer class="shadow-subtle safe-area-bottom bg-neutral-0 flex flex-col border-t border-solid border-neutral-200">
  <div class="flex justify-between px-4 py-4 md:px-6">
    <dojo-button class="w-auto" (click)="resetFilter()" [fill]="'outline'">
      {{ 'assessment.popup.clear_all' | transloco }}
    </dojo-button>
    <dojo-button (click)="confirm()">{{ 'assessment.popup.apply_filters' | transloco }}</dojo-button>
  </div>
</ion-footer>
